
import React from "react";
import { Shield, Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TrustBadges = () => {
  const { language } = useLanguage();

  const content = {
    fr: {
      security: "Sécurisé à 100%",
      satisfaction: "Satisfait ou remboursé"
    },
    en: {
      security: "100% Secure",
      satisfaction: "Money-back guarantee"
    },
    de: {
      security: "100% sicher",
      satisfaction: "Geld-zurück-Garantie"
    }
  };

  return (
    <div className="flex flex-wrap justify-center gap-6 items-center">
      <div className="flex items-center gap-2">
        <Shield className="w-5 h-5 text-legatia-orange" />
        <span className="text-sm text-gray-600">{content[language].security}</span>
      </div>
      <div className="flex items-center gap-2">
        <Check className="w-5 h-5 text-legatia-green" />
        <span className="text-sm text-gray-600">{content[language].satisfaction}</span>
      </div>
    </div>
  );
};

export default TrustBadges;
